import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';

@inject('userStore')
@observer
class ModalCancel extends Component {
    constructor(props){
        super(props);
        this.cancelInquiry = this.cancelInquiry.bind(this);
        this.handleModalHandler = this.handleModalHandler.bind(this)
    }

    handleModalHandler(){
        this.props.handler();
    }

    cancelInquiry(){
        // deny - submit and send message along with personalized message if any, change sys_book_type_status_id to inactive
        post('v2/save/acceptance', {
                bk_temp_hash_id: this.props.inquiry.hash_id,
                accept:-1
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              console.log(res.data);
              this.props.inquiry.sys_status_id = res.data.sys_status_id;
              this.handleModalHandler();
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }

  render() {
      if (!this.props.inquiry) return <div className="alert alert-danger">No Inquiry Loaded</div>;
    return (
    	<React.Fragment>
            <p className="lead">If you are sure you would like to cancel this inquiry, click the Cancel Button below.</p>
            <button className="btn btn-w-md btn-danger" onClick={this.cancelInquiry}>Cancel</button>
        </React.Fragment>
    )
  }
}

export default ModalCancel;



// WEBPACK FOOTER //
// ./src/components/business/ModalCancel.js